import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import CustomerDataPopup from './CustomerDataPopup'
import Submit from 'components/inputs/Submit'
import Receipt from './Receipt'
import CheckoutRecipients from 'containers/Account/InvoiceRecipients/CheckoutRecipients'

const User = ({ isDesktop, user, customer, customerValidation, isIncomplete = false, onSaved, waitForSync, next, isChecking = false }) => {
  const { popup, openPopup } = usePopupState()
  const { t } = useTranslation()

  return (
    <>
      {popup === 'userData' && <CustomerDataPopup
        customer={customer || user}
        customerValidation={customerValidation}
        onSaved={onSaved}
        waitForSync={waitForSync}
      />}
      <Receipt
        data={user}
        warning={isIncomplete ? t('form.missingContractData') : undefined}
        editAction={() => {
          openPopup('userData')
        }}
      />
      <CheckoutRecipients />
      {!isDesktop && <div className='receipt__button'>
        <Submit
          text={t('basic.next')}
          isLoading={isChecking}
          block={isChecking}
          action={next} />
      </div>}
    </>
  )
}

export default User
